import * as React from "react";
import { SVGProps, memo } from "react";

const IcSharpNfc = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22 2H2V22H22V2ZM20 20H4V4H20V20ZM18 6H11V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V8H16V16H8V8H10V6H6V18H18V6Z" fill="currentColor" /></svg>;

const Memo = memo(IcSharpNfc);
export default Memo;